/**
 * Amenities & notes edit section for the venue page Details tab.
 */
import { useState } from 'react';

import { Field } from '../venueCreateFields';

import { AmenitiesView } from './AmenitiesView';
import { AmenityChips } from './AmenityChips';
import { EditSection } from './EditSection';
import { nullable, type SectionProps } from './section-props';
import { Textarea, useFormDraft } from './sectionHelpers';

export function AmenitiesSection({ venue, readOnly, save }: SectionProps) {
  const seed = { amenities: venue.amenities, notes: venue.venueNotes ?? '' };
  const { draft, setDraft, setField, reset } = useFormDraft(seed, venue.updatedAt);
  const [pending, setPending] = useState('');

  const addAmenity = () => {
    const a = pending.trim();
    if (a.length === 0 || draft.amenities.includes(a)) return;
    setDraft((d) => ({ ...d, amenities: [...d.amenities, a] }));
    setPending('');
  };
  const removeAmenity = (a: string) =>
    setDraft((d) => ({ ...d, amenities: d.amenities.filter((x) => x !== a) }));

  return (
    <EditSection
      title="Amenities & notes"
      hint="internal"
      readOnly={readOnly}
      onCancel={() => {
        reset();
        setPending('');
      }}
      onSave={() => save({ amenities: draft.amenities, venueNotes: nullable(draft.notes) })}
      view={<AmenitiesView amenities={venue.amenities} notes={venue.venueNotes} />}
      form={
        <div>
          <AmenityChips
            amenities={draft.amenities}
            pending={pending}
            setPending={setPending}
            onAdd={addAmenity}
            onRemove={removeAmenity}
          />
          <Field label="Staff notes">
            <Textarea value={draft.notes} onChange={(v) => setField('notes', v)} />
          </Field>
        </div>
      }
    />
  );
}
